<div
  *ngIf="isLoading"
  class="u-position-absolute"
  [ngStyle]="{ top: 0, left: 0, right: 0 }"
  [@fadeInEnter]
>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div
  [ngStyle]="{ width: '760px', maxWidth: '95vw', minHeight: '100vh' }"
  class="u-margin-center u-padding-40-0"
>
  <div
    class="u-borderBottom-grey100 u-paddingBottom-24 u-marginBottom-32 u-textAlign-center"
  >
    <app-avatar-tenant
      class="u-display-inlineBlock u-marginBottom-16"
      [item]="tenant"
      [size]="96"
    >
    </app-avatar-tenant>
    <h5
      i18n="@@userOnboardingView.introGoalsSelection.title"
      class="u-textDecoration-bold"
    >
      Who can we connect you with?
    </h5>
    <div
      class="color-grey-300 u-text-maxWidth u-margin-center u-marginBottom-16"
    >
      <p
        class="u-display-inline"
        i18n="@@userOnboardingView.introGoalsSelection.overview"
      >
        You'll be connected with people in the selected categories. You can
        uncheck a category so you won't be automatically connected to people
        from that category. This step is optional
      </p>
      (<button
        i18n="@@userOnboardingView.introGoalsSelection.skipCta"
        class="c-button u-textDecoration-underline"
        (click)="navigateToNextView.emit(group)"
      >
        skip ahead</button
      >)
    </div>
    <app-progress-steps
      fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="center center"
      class="u-display-block"
      [currentStep]="4"
      [numberOfSteps]="5"
    >
    </app-progress-steps>
  </div>
  <div
    *ngIf="matchConfig"
    [@fadeInEnter]
    [ngStyle]="{ maxWidth: '579px' }"
    class="u-margin-center"
  >
    <app-group-intro-selections-form
      class="u-display-block"
      [group]="group"
      [matchConfig]="matchConfig"
      [user]="user"
      (selectionChange)="selectionChange($event)"
    >
    </app-group-intro-selections-form>
    <p
      *ngIf="errorMessage"
      [@fadeInEnter]
      class="color-orange text-caption u-marginBottom-16"
    >
      <ng-container
        i18n="@@userOnboardingView.introGoalsSelection.error"
        >{errorMessage, select, other {{{ errorMessage }}}
      }</ng-container>
    </p>
    <button
      mat-raised-button
      aria-label="Continue"
      color="primary"
      [disabled]="isLoading || isSaving"
      (click)="save(group, user, selections, matchConfig)"
    >
      <i
        *ngIf="isSaving"
        nz-icon
        nzType="sync"
        nzTheme="outline"
        nzSpin
        class="u-marginRight-8"
      ></i>
      <span i18n="@@global.continue"> Continue </span>
    </button>
  </div>
</div>
